import React from 'react';
import Dropdown, { SearchInputProps, searchPrefix } from '../Basics/Dropdown';

const provinceMap = require('./Provinces.json');

const provincesOptions = Object.keys(provinceMap)
  .map((k: string) => {
    return { value: k, text: provinceMap[k], key: k };
  })
  .sort((a, b) => a.text.localeCompare(b.text));

const ProvinceInput: React.FC<SearchInputProps> = ({ autoComplete, type, ...props }) => {
  return (
    <Dropdown
      placeholder='Choose a Province'
      {...props}
      search={searchPrefix}
      searchInput={{ autoComplete, type }}
      options={provincesOptions}
    />
  );
};

export default ProvinceInput;
